
import { Component, Vue } from "vue-property-decorator";
import { RegisterRouter } from "@root/core/router";
import { ObjectHelper, toEnumInterface } from "@root/core";
import { BaseView } from "@root/components";
import { ProjectView } from "@/views/project-view";

@Component
export default class FormCore extends ProjectView {
    value = null;

    get form_inf() {
        return require("raw-loader!./form-core.interface").default;
    }

    get transformedValue() {
        if (this.value == null) return this.value;

        return ObjectHelper.deepReplace(ObjectHelper.deepClone(this.value), (input) => {
            if (input instanceof File) {
                return `${input.name} (${input.size})`;
            }
        });
    }

    log(data) {
        this.console.log("submit:", data);
    }
}
